<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      apiUrl : 'https://22996139781.thesite.link'
      // apiUrl : 'http://localhost:5000'
    }
  }
}
</script>

<style lang="scss">
  @import 'scss/main.scss';

</style>
